/** ************************************************************************
 * Atomic Component for the bPerx iFrame UI.
 *
 * Atomic Type: Content, static (content that never/rarely changes)
 * Purpose: Display the "this gift does not auto renew..." text
 *
 * @file   Atomic Component, content static, this gift... text
 * @author Paul J Stales
 * @since  2.2.0
 ************************************************************************ */

import { FunctionalComponent, h } from 'preact'
import { TransactionInformation } from '../../../../../../common/types/transactionInformationTypes/TransactionInformation'
import OfferTermsLink from '../../contentDynamicComponents/offerTermsLink'
import { css } from 'aphrodite'
import { IFRAME_CLASSNAMES } from '../../../../../../common/constants/ConstantsIFrameClassNames'
import { PartnerSuppliedInfo } from '../../../../../../common/types/partnerSuppliedInfoTypes/PartnerSuppliedInfo'

/**
 * Props Interface for OfferNoChargeText
 */
interface OfferNoChargeTextProps {
  styles: { [key: string]: any }
  noChargeText: string
  areTermsVisible: boolean
  setTermsVisible: (areTermsVisible: boolean) => void
  partnerSuppliedInfo: PartnerSuppliedInfo
  transactionInformation: TransactionInformation
  setTransactionInformation: (ti: TransactionInformation) => void
  setDoesPartnerNeedUpdateForTransactionInformation: (b: boolean) => void
}

/**
 * The single-line text explaining there are no strings attached.
 * @param OfferNoChargeTextProps
 * @returns
 */
const OfferNoChargeText: FunctionalComponent<OfferNoChargeTextProps> = ({
  styles,
  noChargeText,
  areTermsVisible,
  setTermsVisible,
  partnerSuppliedInfo,
  transactionInformation,
  setTransactionInformation,
  setDoesPartnerNeedUpdateForTransactionInformation
}) => {
  return (
    <p
      class={`${IFRAME_CLASSNAMES.BPERX_NO_AUTO_RENEW_TEXT}${' '}${
        styles[IFRAME_CLASSNAMES.BPERX_NO_AUTO_RENEW_TEXT] === undefined
          ? ''
          : css(styles[IFRAME_CLASSNAMES.BPERX_NO_AUTO_RENEW_TEXT])
      }`}
    >
      {noChargeText}
      <br />
      <OfferTermsLink
        styles={styles}
        linkText={
          partnerSuppliedInfo.partnerCustomizations?.offerTermsLinkText
            ? partnerSuppliedInfo.partnerCustomizations.offerTermsLinkText
            : 'View Offer Details'
        }
        areTermsVisible={areTermsVisible}
        setTermsVisible={setTermsVisible}
        partnerSuppliedInfo={partnerSuppliedInfo}
        transactionInformation={transactionInformation}
        setTransactionInformation={setTransactionInformation}
        setDoesPartnerNeedUpdateForTransactionInformation={
          setDoesPartnerNeedUpdateForTransactionInformation
        }
      />
    </p>
  )
}

export default OfferNoChargeText
